module.exports = __webpack_public_path__ + "media/assets/images/blog/betafeaturewip-small-985250b26cb01958c7da27965cb4b84c.png";